import FormInputTypes from "../components/atoms/formEnums/formInputTypes";
import tableAppBlackoutsContent from "./tableAppBlackoutsContent";

export default {
  title: 'API Urls',
  attributeName: 'apiUrls',
  fields: [
    {
      attributeName: 'playbackMetadataClientAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Client API PlaybackMetadata',
      helpText:"",
    },
    {
      attributeName: 'extendedInfoClientAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Client API Extended Info',
      helpText:"",
    },
    {
            attributeName:"sep1",
            type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'playbackMetadataSpacesAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Spaces API Url',
      helpText: '',
    },
      {
      attributeName: 'extendedInfoSpacesAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Spaces API Extended Info',
      helpText: '',
    },
  ],
};
